import arrayUtils from 'tradera-apps/syi/script/app_react/utils/array-utils';
import draftActions from './draft-actions';
import { getSyiSlice } from 'tradera-state/configure-store';

const setDraftImages = images => dispatch => {
    dispatch({
        type: 'SET_DRAFT_IMAGES',
        payload: images
    });

    dispatch(draftActions.updateDraftCanBeResumed());
};

const setUploadedImageInNextFreeSlot = (imageId, imageUrl) => (
    dispatch,
    getState
) => {
    var slots = getSyiSlice(getState()).images.slots;
    var freeSlotIndex = -1;
    for (var i = 0; i < slots.length; i++) {
        if (!slots[i].imageId) {
            freeSlotIndex = i;
            break;
        }
    }
    if (freeSlotIndex > -1) {
        dispatch({
            type: 'SET_UPLOADED_IMAGE_IN_SLOT',
            slotIndex: freeSlotIndex,
            imageUrl: imageUrl,
            imageId: imageId
        });
    }

    dispatch(draftActions.updateDraftCanBeResumed());
};

const removeImageInSlot = slotIndex => (dispatch, getState) => {
    let slots = arrayUtils.shallowCopyArrayObjects(
        getSyiSlice(getState()).images.slots
    );
    // move images to the left
    for (var i = slotIndex; i < slots.length - 1; i++) {
        slots[i].imageUrl = slots[i + 1].imageUrl;
        slots[i].imageId = slots[i + 1].imageId;
        slots[i].rotationDegrees = slots[i + 1].rotationDegrees;
        slots[i].isListingImage = slots[i + 1].isListingImage;
        if (slots[i + 1].isListingImage) {
            slots[i].filename = slots[i + 1].filename;
            slots[i].imageGroupId = slots[i + 1].imageGroupId;
        }
    }

    // reset last slot
    slots[4].isUploading = false;
    slots[4].imageUrl = null;
    slots[4].imageId = null;
    slots[4].isListingImage = false;
    slots[4].filename = null;
    slots[4].imageGroupId = null;

    dispatch({
        type: 'SET_IMAGE_SLOTS',
        slots: slots
    });

    dispatch(draftActions.updateDraftCanBeResumed());
};

const changeImagePosition = (from, to) => (dispatch, getState) => {
    var slots = getSyiSlice(getState()).images.slots;
    var slot = slots[from];
    slots.splice(from, 1);
    var len = slots.length;
    var newSlots = [];
    for (var i = 0; i < len; i++) {
        if (i == to) {
            newSlots.push(slot);
        }
        newSlots.push(slots[i]);
    }
    if (to == slots.length) {
        newSlots.push(slot);
    }
    dispatch({
        type: 'SET_IMAGE_SLOTS',
        slots: newSlots
    });
};

const removeImageWithId = imageId => (dispatch, getState) => {
    let slots = getSyiSlice(getState()).images.slots;
    let slotIndex = -1;
    for (var i = slots.length; i-- > 0; ) {
        if (slots[i].imageId === imageId) {
            slotIndex = i;
            break;
        }
    }
    if (slotIndex > -1) {
        dispatch(removeImageInSlot(slotIndex));
    }

    dispatch(draftActions.updateDraftCanBeResumed());
};

const rotateImage = slotIndex => (dispatch, getState) => {
    var slots = getSyiSlice(getState()).images.slots;
    var rotationDegrees = slots[slotIndex].rotationDegrees || 0;
    rotationDegrees += 90;
    if (rotationDegrees === 360) {
        rotationDegrees = 0;
    }
    dispatch({
        type: 'SET_IMAGE_ROTATION',
        slotIndex: slotIndex,
        rotationDegrees: rotationDegrees
    });
};

const setUploadFailed = errorMessage => dispatch => {
    dispatch({
        type: 'SET_IMAGE_UPLOAD_FAILED',
        payload: errorMessage
    });
};

const setUploading = numberOfSlots => dispatch => {
    dispatch({
        type: 'SET_IMAGES_UPLOADING',
        numberOfSlots: numberOfSlots
    });
};

const reset = () => dispatch => {
    dispatch(setDraftImages([]));
    dispatch(draftActions.updateDraftCanBeResumed());
};

export default {
    setDraftImages,
    setUploadedImageInNextFreeSlot,
    removeImageInSlot,
    removeImageWithId,
    changeImagePosition,
    rotateImage,
    setUploadFailed,
    setUploading,
    reset
};
